import { Injectable } from '@angular/core';
import { DomStorageFallbackService } from './../DomStorageFallback.service';
import { IDBService } from './../indexdb/idb.service';
import { AppConstants } from './../../constants/app-constants';
import { AppUtility } from './../../utils/utility';
import { Observable } from 'rxjs';
import { LoggingService } from './logging.service';

@Injectable()
export class LogFrontendError {
    /* istanbul ignore next */
    constructor(private domStorageFB: DomStorageFallbackService, private idbService: IDBService, private appUtility: AppUtility) { }

    /* istanbul ignore next */
    public setErrorDataToIDB(error, requestType?, urlOptions?, body?, key?, docObjectRef?, consumerRefIDValue?) {
        const finalErrorObj = [
            {
                'error': error,
                'requestType': requestType,
                'urlOptions': urlOptions,
                'body': body,
                'key': key,
                'consumerRefIDValue': consumerRefIDValue
            }
        ];
        const splitEndPoint = urlOptions.endPoint.split('/');
        const extractEndPoint = splitEndPoint.length;
        const getEndPoint = splitEndPoint[extractEndPoint - 1];
        if (finalErrorObj) {
            this.idbService.addRecordsInObjStore(AppConstants.UPN_Error_Logs, finalErrorObj, getEndPoint + Date.now()).subscribe((res: String) => {
                if (LoggingService.uConsole) {
                    console.log('LogFrontendError service addRecordsInObjStore fn', res);
                }
            }, e => {
                if (LoggingService.uConsole) {
                    console.log('LogFrontendError service addRecordsInObjStore fn', e);
                }
            });
        }
    }

    /* istanbul ignore next */
    public getConsoles() {
        try {
            if ((<any>window).console && (<any>window).console.history && (<any>window).console.history.length >= 0) {
                return (<any>window).console.history;
            } else {
                return 'no console are available.';
            }
        } catch (e) {
            if (LoggingService.uConsole) {
                console.log('LogFrontendError service getConsoles fn', e);
            }
        }
    }

    /* istanbul ignore next */
    public getSessionStorage() {
        // this.domStorageFB.getAllItem('', false);
        return (<any>window).sessionStorage;
    }

    /* istanbul ignore next */
    public getLocalStorage() {
        // this.domStorageFB.getAllItem('localStorage', false);
        return (<any>window).localStorage;
    }

    /* istanbul ignore next */
    public getCookie() {
        // this.domStorageFB.getCookie();
        return (<any>window).document.cookie;
    }

    /* istanbul ignore next */
    getErrorAPIdata(): Observable<any> {
        return this.idbService.getAllRecordsAsync(AppConstants.UPN_Error_Logs).map(
            data => {
                const blob: Blob = new Blob([data]);
                this.appUtility.downloadFile(blob, AppConstants.UPN_Error_Logs);
                // return this.getAllErrorEndPoints(data);
            }, error => {
                if (LoggingService.uConsole) {
                    console.log('LogFrontendError service getErrorAPIdata fn -> ', error);
                }
            });
    }

    /* istanbul ignore next */
    getAllErrorEndPoints(data) {
        const getAllEndPoints = [];
        const getParseData = JSON.parse(data);
        Object.keys(getParseData).forEach(key => {
            JSON.parse(getParseData[key]).forEach(node => {
                Object.keys(JSON.parse(node)).forEach(keyC => {
                    if (JSON.parse(node)[keyC][0].hasOwnProperty('urlOptions')) {
                        if (JSON.parse(node)[keyC][0].urlOptions.hasOwnProperty('endPoint')) {
                            const endPoint = JSON.parse(node)[keyC][0].urlOptions.endPoint.split('/');
                            const getEndPoints = endPoint[endPoint.length - 1];
                            if (getAllEndPoints.indexOf(getEndPoints) === -1 && this.idbService.idbStoreList.indexOf(getEndPoints) !== -1) {
                                getAllEndPoints.push(getEndPoints);
                                this.getAllErrorAPIResponse(getEndPoints);
                            }
                        }
                    }
                });
            });
        });
    }

    /* istanbul ignore next */
    getAllErrorAPIResponse(key) {
        this.idbService.getAllRecordsAsync(key).subscribe(
            data => {
                const blob: Blob = new Blob([data]);
                this.appUtility.downloadFile(blob, key);
            }, error => {
                if (LoggingService.uConsole) {
                    console.log('LogFrontendError service getAllErrorAPIResponse fn -> ', error);
                }
            });
    }

}
